
import React from 'react';
import { HubSpotFormEmbed } from './HubSpotFormEmbed';
import { sanitizeHtml } from '@/utils/security';

interface ConsultationFormProps {
  formId?: string;
  onSubmitted?: () => void;
  calculationResult?: number | null;
  industryType?: string;
}

export const ConsultationForm = ({ 
  formId = "dfa977cc-c726-4029-89d1-d8f757482a67",
  onSubmitted,
  calculationResult,
  industryType
}: ConsultationFormProps) => {
  // Prepare and sanitize hidden fields that should be passed to HubSpot
  const hiddenFields: Record<string, string> = {};
  
  if (calculationResult !== undefined && calculationResult !== null) {
    // Validate calculation result is a reasonable number
    const sanitizedResult = Math.max(0, Math.min(calculationResult, 10000000)); // Cap at 10M
    hiddenFields.calculated_value = sanitizedResult.toString();
  }
  
  if (industryType) {
    // Sanitize industry type to prevent XSS
    hiddenFields.industry = sanitizeHtml(industryType).substring(0, 100);
  }

  return (
    <div className="consultation-form bg-white rounded-md">
      <HubSpotFormEmbed
        formId={formId}
        onFormSubmitted={onSubmitted}
        hiddenFields={hiddenFields}
        className="w-full"
      />
    </div>
  );
};
